window.addEventListener('DOMContentLoaded', () => {
	//accordion
	const acc_btn = Array.from(document.querySelectorAll('.accordion__button'));

	for(let i=0; i< acc_btn.length; i++){
		let ttl = acc_btn[i];
		let content = ttl.nextElementSibling;
		ttl.addEventListener('click',()=>{
			ttl.classList.toggle('open');
			content.classList.toggle('open');
			if (content.style.height) {
				content.style.height = null;
			} else {
				content.style.height = content.scrollHeight + 'px';
			}
		});
	}
	
	// anchor link
    const anchorLinks = document.querySelectorAll('a[href^="#"]')
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
    const header = document.querySelector('header');
  
    anchorLinksArr.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const targetId = link.hash;
        const targetElement = document.querySelector(targetId);
        const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
        const headerHeight = header.offsetHeight;
        const totalScrollAmount = targetOffsetTop - headerHeight;
        window.scrollTo({
          top: totalScrollAmount,
          behavior: "smooth"
        });
      });
    });
	
	
	const hash = window.location.hash;
    if (hash) {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
            const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
            const headerHeight = header.offsetHeight;
            const totalScrollAmount = targetOffsetTop - headerHeight;

            window.scrollTo({
                top: totalScrollAmount,
                behavior: "smooth"
            });

            const targetAccordion = targetElement.closest('.accordion__button');
            if (targetAccordion) {
                const content = targetAccordion.nextElementSibling;
                targetAccordion.classList.add('open');
                content.classList.add('open');
                content.style.height = content.scrollHeight + 'px';
            }
        }
    }
	
});
